/** User avatar upload (keep in sync with Storage bucket + RPC). */
export const USER_AVATARS_BUCKET = 'user-avatars';
export const USER_AVATAR_FILE_NAME = 'avatar.jpg';
export const USER_AVATAR_SIZE_PX = 512;
export const USER_AVATAR_JPEG_QUALITY = 0.9;
export const USER_AVATAR_MAX_BYTES = 1024 * 1024;

export function userAvatarStoragePath(userId: string): string {
  return `${userId}/${USER_AVATAR_FILE_NAME}`;
}
